// extracted by mini-css-extract-plugin
export default {"container":"container__562c95b4","icon":"icon__562c95b4","input":"input__562c95b4","information":"information__562c95b4","reset":"reset__562c95b4"};